<template lang="pug">
  fieldset.option-select.option-select--buttons
    legend.option-select__legend(v-if="label")
      span.option-select__legend--title.u-sr-only {{ label }}
    .option-select__label-wrapper
      label.option-select__label(
        v-for="option in optionSet"
        tabindex="0"
        :class="{ 'is-selected': option.value === value }"
        :disabled="option.disabled"
      )
        icon.option-select__icon(
          :name="option.icon",
          width="60px"
          height="60px"
        )
        .option-select__label__title {{ option.label }}
        input.u-sr-only(
          type="radio"
          tabindex="-1"
          :id="option.label"
          :value="option.value"
          :checked="option.value === value"
          :disabled="option.disabled"
          name="type"
          @change="onChange(option.value)"
        )
</template>

<script>
  import { purchaseTypeSingle, purchaseTypeRecurring } from 'scripts/config/subscriptions.js';

  import OptionSelectButtons from 'scripts/components/forms/OptionSelectButtons.vue';
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'SubscriptionSelectButtons',
    extends: OptionSelectButtons,
    props: {
      disableSubscription: Boolean,
      subscriptionPrice: Number,
      subscriptionDiscount: Number
    },
    components: { Icon },
    mounted() {
      console.log('SubscriptionSelectButtons mounted, value prop:', this.value);
      console.log('SubscriptionSelectButtons optionSet:', this.optionSet);
    },
    computed: {
      optionSet () {
        let options = [
          {
            label: 'One-Time Purchase',
            value: purchaseTypeSingle,
            icon: 'one-time',
          },
        ];

        // Check for selling plans instead of legacy subscription
        if (this.product.selling_plan_groups && this.product.selling_plan_groups.length > 0) {
          options.push({
            label: `Subscribe & Save ${this.subscriptionDiscount}%`,
            value: purchaseTypeRecurring,
            icon: 'subscription',
            discount: this.subscriptionDiscount,
            price: this.subscriptionPrice,
            disabled: this.disableSubscription,
          });
        }

        return options;
      },
    },
  };
</script>

<style scoped lang="scss">
  .option-select__label-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .option-select__label {
    border: 1px solid $color-light-grey;
    padding-top: 0;
    padding-bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;

    &.is-selected {
      border: 2px solid $color-indigo;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
</style>
